module.exports = __webpack_public_path__ + "img/planner.df785dc1.png";